import { cx } from "@jugl-web/utils";
import { FC, HTMLProps } from "react";

export const ListBoxDivider: FC<HTMLProps<HTMLDivElement>> = ({
  className,
  ...props
}) => <div className={cx("h-px w-full bg-dark-100", className)} {...props} />;
